import {ScreenParameters, UpdateManager} from '@gongxigames/framework/core';
import {PopupFaderConfig} from '@gongxigames/framework/slot/types';
import {DisplayObjectUtils} from '@gongxigames/framework/core/services/DisplayObjectUtils';
import {IUpdateManager} from '@gongxigames/framework/core/types';
import {Container} from 'pixi.js';
import {SpineUtils} from '@gongxigames/framework/core/services/SpineUtils';
import {ObjectBuilder} from '@gongxigames/framework/core/services/ObjectBuilder';

export type CallBack = () => void;
export const DEFAULT_FADE_DURATION = 300;

export abstract class Fader {
    readonly container = new Container();
    readonly updater = new UpdateManager(true);

    constructor(
        updateManager: IUpdateManager,
        protected readonly objectBuilder: ObjectBuilder,
        protected readonly displayObjectUtils: DisplayObjectUtils,
        protected readonly spineUtils: SpineUtils,
        protected readonly config: PopupFaderConfig
    ) {
        updateManager.add(this.updater);
        this.container.visible = false;
    }

    public abstract show(cb: CallBack): void;
    public abstract resize(screenParams: ScreenParameters): void;

    protected getFadeDuration(): number {
        return this.config.fadeDuration || DEFAULT_FADE_DURATION;
    }

    public hide(): void {
        this.container.parent?.removeChild(this.container);
        this.updater.stop();
    }
};

